module.exports = __webpack_public_path__ + "img/team-about.3b243909.jpg";